<form [formGroup]="myForm">
  <mat-card>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Role Name</mat-label>
        <input matInput placeholder="Role Name">
      </mat-form-field>
      <div class="__switch_btns">
        <mat-slide-toggle (change)="$event.checked===true ?accordion.openAll():accordion.closeAll()"><span
        class="__switch_txt">Expand All</span></mat-slide-toggle>
        <mat-slide-toggle><span class="__switch_txt">De-activate Client</span></mat-slide-toggle>
      </div>
      <mat-accordion class="example-headers-align" multi>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 cargo_casting">
          @for (col of permissionCol; track col; let index = $index) {
            <ng-container matColumnDef="{{col.id}}">
              <th mat-header-cell *matHeaderCellDef>
                <span class="__row_label">{{col.name}}</span>
                @if (col.id=='processName') {
                  <span>
                    <div class="process_search">
                      <mat-form-field>
                        <mat-icon class="__search_icon">search</mat-icon>
                        <input matInput placeholder="Process" formControlName="processFilter">
                        <button class="__filter_icon" mat-button (click)="openDialog()">
                          <mat-icon>filter_list</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </span>
                }
              </th>
              <td mat-cell *matCellDef="let element;">
                @if (col.id=='permission') {
                  <span>
                    <mat-expansion-panel>
                      @if (col.id=='permission') {
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <p>{{element[col.id]}}</p>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                      }
                      @for (col of element.generalPermission; track col) {
                        <p>
                          <mat-checkbox class="remember-margin" >{{col.permissionName}}</mat-checkbox>
                        </p>
                      }
                    </mat-expansion-panel>
                  </span>
                }
                @if (col.id=='processName') {
                  <span>
                    <mat-checkbox class="remember-margin" [checked]="element.selected">{{element[col.id]}}</mat-checkbox>
                  </span>
                }
                @if (col.id!=='processName' && col.id!=='permission') {
                  <span>
                    <mat-checkbox class="remember-margin"></mat-checkbox>
                  </span>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="permissionColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: permissionColumn;"></tr>
        </table>
      </mat-accordion>


      <mat-card-actions class="document_action">
        <button mat-button color="cancel">CANCEL</button>
        <button mat-button color="primary">SAVE</button>
      </mat-card-actions>
    </mat-card-content>
  </mat-card>
</form>